import { render, staticRenderFns } from "./AddToCartButton.vue?vue&type=template&id=defea330&scoped=true"
import script from "./AddToCartButton.vue?vue&type=script&lang=ts"
export * from "./AddToCartButton.vue?vue&type=script&lang=ts"
import style0 from "./AddToCartButton.vue?vue&type=style&index=0&id=defea330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defea330",
  null
  
)

export default component.exports